import React from 'react';
import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/button';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const StyledActionButton: React.ComponentType<any> = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&&': {
		// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-dynamic-styles
		color: (props: any) =>
			props.isSelected ? token('color.text.inverse') : token('color.text.subtlest'),
		minWidth: '32px',
	},
});

type ActionButtonWrapperProps = {
	forceShow?: boolean;
	children: React.ReactNode;
};

const actionButtonWrapperStyle = css({
	transition: 'ease-in 150ms',
	opacity: 'var(--show-action)',
});

const forceShowStyle = css({
	opacity: '1',
});

// Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about forceShow being passed to the DOM
export const ActionButtonWrapper = ({
	forceShow,
	...rest
}: ActionButtonWrapperProps): React.JSX.Element => (
	<div css={[actionButtonWrapperStyle, forceShow && forceShowStyle]} {...rest} />
);
